import './baseApi'
import './translation'
import './analytics'
import './util'
import './calendar'
import './legacy'
import './validation'
import './optima'
import './shop'
import './wizard'
import './logger'
import './vueModules'
import './giftcard'
import axios from 'axios';

(function (d, s) {
    window.TABS.api.init(d, s)

}(document, 'script'));

window.TABS = window.TABS || {};

// Premium booking form
window.TABS.booking = (function () {
    return {
        loading:      false,
        debugMode:    false,
        step:         'initial',
        personalInfo: [],
        contactInfo:  [],
        // Endpoint is used for GA events
        endpoint:       'courses',
        requirePayment: false,
        credentials:    {},

        debug: function (data) {
            if (this.debugMode) {
                console.log(data)
            }
        },

        showStep: function (step) {
            this.step = step;
            TABS.optima.step = step
            this.setFeedback('');
            document.querySelectorAll('[data-booking-step]').forEach(el => el.classList.add('hide'));
            let stepElement = document.querySelector('[data-booking-step=' + step + ']');
            stepElement.classList.remove('hide');
            if (stepElement.querySelector('.has-feedback')) {
                stepElement.removeAttribute('data-validator');
                TABS.validation.validateStep(step);
            }
            document.querySelectorAll('.modal, .tabs-modal').forEach(el => el.scrollTop = 0);

            if (step === 'company-lookup') {
                document.querySelectorAll('#company-loader').forEach(el => el.classList.remove('hide'));
            }
        },

        setLoading: function (show) {
            this.loading = show;
            if (show) {
                document.querySelectorAll('.modal-body .loader').forEach(el => el.style.display = 'block');
            } else {
                document.querySelectorAll('.modal-body .loader').forEach(el => el.style.display = 'none');
            }
        },

        setFeedback: function (content) {
            document.querySelectorAll('.feedback').forEach(el => el.innerHTML = content);
        },

        setPersonalInfo: function (formdata) {
            formdata.forEach(item => {
                document.querySelector('[data-user=' + item.name + ']').textContent = item.value;
            });
            this.personalInfo = formdata;
            document.querySelector('.personal-info').classList.remove('hide');
        },
        setContactInfo:  function (formdata) {
            formdata.forEach(item => {
                document.querySelector('[data-user=' + item.name + ']').textContent = item.value;
            });
            this.contactInfo = formdata;
            document.querySelector('.contact-info').classList.remove('hide');
        },
        shouldSubmit:    function (e, step) {
            e.preventDefault();

            const isValid = TABS.validation.validateStep(step || TABS.booking.step)
            this.debug({ isValid })
            if (!isValid) {
                return false;
            }

            if (this.loading) {
                return false;
            }

            this.setLoading(true);
            return true;
        },

        /**
         * Requests API-endpoint with formdata
         * @param endpoint
         * @param form
         * @param callback
         * @param data - Optional
         * @param retry - Optional
         * @param errorCallback - Optional
         */
        request:     function (endpoint, form, callback, data, retry, errorCallback) {
            try {
                if (form) {
                    // Disable button
                    form.querySelectorAll('.btn-primary').forEach(el => {
                        el.setAttribute('disabled', 'disabled')
                        el.classList.add('disabled')
                        el.dataset.originalText = el.textContent
                        el.textContent = TABS.$t('Laster...')
                    });
                    data = typeof data !== 'undefined' ? data : new FormData(form);
                    if (TABS.util.getUrlParameter('tabs_jwt')) {
                        data.append('vippsToken', TABS.util.getUrlParameter('tabs_jwt'));
                    }
                }
                console.log('Requesting', endpoint, data);

                axios.post(TABS.api.getEndPoint(endpoint), data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    withCredentials: true
                })
                .then(response => response.data)
                .then(res => {
                    TABS.booking.setLoading(false);
                    if (typeof callback === 'function') {
                        callback(res, form);
                    }
                })
                .catch(e => {
                    if (retry) {
                        if (typeof retry === 'number') {
                            retry--;
                        } else {
                            retry = false;
                        }
                        setTimeout(() => {
                            TABS.booking.request(endpoint, form, callback, data, retry);
                        }, 300);
                        return;
                    }
                    if (e.message === "Network Error") {
                        TABS.booking.ajaxError(form, TABS.$t('Nettverksfeil. Prøv igjen.'));
                        return
                    }

                    TABS.booking.reportError(data, endpoint, e.status, e);
                    TABS.booking.triggerAnalyticsEvent('booking', endpoint, 0);
                    TABS.booking.ajaxError(form);
                    console.error(e);
                    if (typeof errorCallback === 'function') {
                        errorCallback(e);
                    }
                })
                .finally(() => {
                    if (!form) {
                        return
                    }
                    form.querySelectorAll('.btn-primary').forEach(el => {
                        el.removeAttribute('disabled')
                        el.classList.remove('disabled')
                        el.textContent = el.dataset.originalText
                    });
                });
            } catch (e) {
                TABS.optima.postingForm = false;
                TABS.booking.reportError({
                    message: 'Failed to submit request fully',
                }, endpoint, e.status, e);
                console.error(e);
                if (typeof errorCallback === 'function') {
                    errorCallback(e);
                }
            }
        },
        reportError: function (data, endpoint, status, error = null) {
            if (data instanceof FormData) {
                data = Object.fromEntries(data.entries());
            }

            const errorDetails = error ? {
                message: error.message || 'Unknown error',
                status: error.response?.status || status || 'No status',
                statusText: error.response?.statusText || 'No status text',
                url: error.config?.url || 'No URL',
                method: error.config?.method || 'No method',
                stack: error.stack || 'No stack trace'
            } : null;

            axios.post(TABS.api.getEndPoint('report-error'), {
                data,
                endpoint,
                status,
                errorDetails
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        },

        // Perform lookup and display correct form after
        // depending on user exists or not
        lookup: function (e) {
            this.step = 'initial';
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = document.querySelector('[data-booking-step=initial]');
            this.request('check_mobile', form, this.lookupSuccessCallback);
        },
        // Lookup success response callback
        lookupSuccessCallback: function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');
            // Set username field in other steps
            document.querySelector('input[name=username]').value = form.querySelector('input[name=username]').value;
            if (form.querySelector('select[name=countrycode]')) {
                document.querySelector('select[name=countrycode]').value = form.querySelector('select[name=countrycode]').value;
            }
            if (res.error) {
                return TABS.booking.showError(res.error);
            }
            if (res.exists) {
                return TABS.booking.showStep('login');
            }
            return TABS.booking.showStep('register');
        },

        // Attempt to register with current form input
        register: function (e) {
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = e.target;
            this.request('register', form, this.registerSuccessCallback);
        },

        // Register request successful, show correct response
        // Either register with contact form or login if age is > 18
        registerSuccessCallback: function (result, form) {
            var __this = window.TABS.booking;
            form.querySelector('button.btn-primary').removeAttribute('disabled');
            form.querySelector('button.btn-primary').textContent = 'Fortsett';

            __this.triggerAnalyticsEvent('booking', 'register', result.status === 'ok' ? 1 : 0);
            if (result.status === 'ok') {
                if (typeof result.age !== 'undefined') {
                    document.getElementById('contact-person-message').textContent = TABS.$t('Ettersom du ikke er myndig trenger vi informasjon om en foresatt.');
                    __this.age = result.age;
                    __this.setPersonalInfo(form.serializeArray());
                    __this.showStep('contact-person');
                    return;
                } else {
                    __this.showStep('login');
                    document.getElementById('login-message').textContent = TABS.$t('Vi har sendt deg en SMS med passordet ditt. Benytt dette for å fullføre bestillingen.');
                    document.getElementById('login-message').classList.add('alert', 'alert-danger');
                    return;
                }
            }
            __this.showError(result.message);
        },

        registerWithContact: function (e) {
            if (!this.shouldSubmit(e)) {
                return;
            }
            const form = e.target;
            const data = new FormData();
            this.personalInfo.forEach(item => data.append(item.name, item.value));
            new FormData(form).forEach((value, key) => data.append(key, value));
            this.request('register', form, this.registerWithContactCallback, data);
        },

        registerWithContactCallback: function (result, form) {
            form.querySelector('button.btn-primary').removeAttribute('disabled');
            form.querySelector('button.btn-primary').textContent = TABS.$t('Fortsett');
            TABS.booking.triggerAnalyticsEvent('booking', 'register-with-contact', result.status === 'ok' ? 1 : 0);
            if (result.status === 'ok') {
                TABS.booking.setContactInfo(form.serializeArray());
                TABS.booking.showStep('login');
                if (result.user_id) {
                    return;
                }
                document.getElementById('login-message').textContent = TABS.$t('Vi har sendt deg en SMS med passordet ditt. Benytt dette for å fullføre bestillingen.');
                document.getElementById('login-message').classList.add('alert', 'alert-danger');
                return;
            }
            TABS.booking.showError(result.message);

        },

        login: function (e) {
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = e.target;
            if (TABS.booking.requirePayment) {
                this.request('login', form, this.loginCallback);
            } else {
                this.request('do_booking', form, this.loginCallback);
            }
        },
        loginCallbackLabel: 'login',
        loginCallback: function (result, form) {
            TABS.booking.setLoading(false)
            form.querySelectorAll('button.btn-primary, div.btn-primary').forEach(el => {
                el.removeAttribute('disabled');
                el.classList.remove('disabled');
                el.textContent = TABS.booking.requirePayment ? TABS.$t('Til betaling') : TABS.$t('Fullfør');
            });
            TABS.booking.triggerAnalyticsEvent('booking', TABS.booking.loginCallbackLabel, result.status === 'ok' ? 1 : 0);

            if (result.status === 'ok') {
                if (TABS.booking.requirePayment) {
                    TABS.booking.credentials.userId = result.user_id
                    TABS.booking.credentials.password = form.querySelector('input[name=password]').value
                    TABS.booking.showStep('paymentMethod');
                    return;
                }
                document.querySelector('[data-booking-step=complete]').innerHTML = result.html;
                const bookingTitle = document.querySelector('.booking-title');
                if (bookingTitle) {
                    bookingTitle.classList.add('hide')
                }
                if (typeof result.purchaseEvent !== 'undefined') {
                    TABS.analytics.triggerPurchaseEvent(result.purchaseEvent);
                }
                return TABS.booking.showStep('complete');
            }
            TABS.booking.showError(result.message);
            document.querySelector('#logged-in-state .btn-primary').textContent = TABS.$t('Logg ut')
        },

        resetPassword: function (e) {
            e.preventDefault();
            if (!this.shouldSubmit(e)) {
                return;
            }
            const form = e.target;
            this.request('reset_password', form, TABS.booking.resetPasswordCallback);
        },

        resetPasswordCallback: function (result, form) {
            form.querySelectorAll('.btn-primary').forEach(el => el.textContent = TABS.$t('Send passord'));
            if (result.status === 'ok') {
                document.querySelectorAll('[data-booking-step=reset-password] input[name=username]').forEach(el => el.value = '');
                TABS.booking.showSuccess(result.html);
                setTimeout(function () {
                    TABS.booking.showStep('login');
                }, 3000);
            } else {
                form.querySelector('.btn-primary').removeAttribute('disabled');
                TABS.booking.showError(result.message);
            }
        },

        orgLogin: function (e) {
            this.step = 'org-login';
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = e.target;
            this.request('do_booking', form, this.loginCallback);
        },

        // Lookup company
        companyLookup: function (e) {
            this.step = 'company-lookup';
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = document.querySelector('[data-booking-step=company-lookup]');
            this.request('company-lookup', form, this.companyLookupSuccessCallback);
        },
        // Lookup success response callback
        companyLookupSuccessCallback: function (res, form) {
            var __this = TABS.booking;
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');

            if (!res.success) {
                __this.showError(res.message);
                return;
            }
            // Set username field in other steps
            document.querySelectorAll('input[name=company-org-number]').forEach(el => el.value = res.data['org-number']);
            document.querySelector('input[name=company-name]').value = res.data.name;
            if (res.data.name === null) {
                document.querySelectorAll('input[name=company-name]').forEach(el => el.removeAttribute('disabled'));
                document.querySelectorAll('input[name=company-address]').forEach(el => el.setAttribute('required', 'required'));
                document.querySelectorAll('input[name=company-address]').forEach(el => el.parentElement.classList.remove('hide'));
                document.querySelectorAll('input[name=company-postal-code]').forEach(el => el.setAttribute('required', 'required'));
                document.querySelectorAll('input[name=company-postal-code]').forEach(el => el.parentElement.classList.remove('hide'));
                document.querySelectorAll('input[name=company-city]').forEach(el => el.setAttribute('required', 'required'));
                document.querySelectorAll('input[name=company-city]').forEach(el => el.parentElement.classList.remove('hide'));
            } else {
                document.querySelectorAll('input[name=company-name]').forEach(el => el.setAttribute('disabled', 'disabled'));
                document.querySelectorAll('input[name=company-address]').forEach(el => el.removeAttribute('required'));
                document.querySelectorAll('input[name=company-address]').forEach(el => el.parentElement.classList.add('hide'));
                document.querySelectorAll('input[name=company-postal-code]').forEach(el => el.removeAttribute('required'));
                document.querySelectorAll('input[name=company-postal-code]').forEach(el => el.parentElement.classList.add('hide'));
                document.querySelectorAll('input[name=company-city]').forEach(el => el.removeAttribute('required'));
                document.querySelectorAll('input[name=company-city]').forEach(el => el.parentElement.classList.add('hide'));
            }
            return __this.showStep('company-confirm');
        },

        companyConfirm: function (e) {
            this.step = 'company-confirm';
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = document.querySelector('[data-booking-step=company-confirm]');
            this.request('company-confirm', form, this.companyConfirmCallback);
        },

        companyConfirmCallback: function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');
            if (!res.success) {
                TABS.booking.showError(res.message);
                return;
            }

            const companyContactMobile = form.querySelector('input[name=company-contact-mobile]').value;
            const companyContactCountryCode = form.querySelector('select[name=company-contact-countrycode]') ? form.querySelector('select[name=company-contact-countrycode]').value : ''
            const companyContactName = form.querySelector('input[name=company-contact-name]').value;
            const companyComment = form.querySelector('textarea[name=company-comment]') ? form.querySelector('textarea[name=company-comment]').value : '';

            document.querySelectorAll('input[name=company-contact-mobile]').forEach(el => el.value = companyContactMobile)
            if (form.querySelector('select[name=company-contact-countrycode]')) {
                document.querySelectorAll('select[name=company-contact-countrycode]').forEach(el => el.value = companyContactCountryCode);
            }
            document.querySelectorAll('#company-confirm-booking-form input[name=company-contact-name]').forEach(el => el.value = companyContactName);
            document.querySelectorAll('#company-confirm-booking-form textarea[name=company-comment]').forEach(el => el.value = companyComment);
            TABS.booking.showStep('company-login');
            TABS.booking.showSuccess(res.message);
        },

        companyLogin:         function (e) {
            this.step = 'company-login';
            if (!this.shouldSubmit(e)) {
                return;
            }
            var form = document.querySelector('[data-booking-step=company-login]');
            this.request('company-login', form, this.companyLoginCallback);

        },
        companyLoginCallback: function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');
            if (!res.success) {
                TABS.booking.showError(res.message);
                return;
            }
            if (res.data['company-register-students']) {
                document.querySelector('#company-confirm-booking-form input[name=company-org-number]').value = res.data['company-org-number'];
                document.querySelector('#company-confirm-booking-form input[name=company-name]').value = res.data['company-name'];
                document.querySelector('#company-confirm-booking-form input[name=company-contact-mobile]').value = res.data['mobile'];
                document.querySelector('#company-confirm-booking-form input[name=company-booking-token]').value = res.data['company-booking-token'];
                document.querySelector('#company-add-student-form input[name=company-booking-token]').value = res.data['company-booking-token'];
                if (res.data['partnership-id']) {
                    document.querySelector('#company-confirm-booking-form select[name=partnership-id]').value = res.data['partnership-id'];
                }

                TABS.booking.showStep('company-add-student');
                TABS.booking.showSuccess(res.message);
                return;
            }
            document.querySelector('#company-confirm-booking-form input[name=company-org-number]').value = res.data['company-org-number'];
            document.querySelector('#company-confirm-booking-form input[name=company-name]').value = res.data['company-name'];
            document.querySelector('#company-confirm-booking-form input[name=company-contact-mobile]').value = res.data['mobile'];
            document.querySelector('#company-confirm-booking-form input[name=company-booking-token]').value = res.data['company-booking-token'];
            document.querySelector('#company-confirm-booking-form input[name=company-quantity]').value = res.data['company-quantity'];
            if (res.data['partnership-id']) {
                document.querySelector('#company-confirm-booking-form select[name=partnership-id]').value = res.data['partnership-id'];
            }

            TABS.booking.showStep('company-confirm-booking');
            TABS.booking.showSuccess(res.message);
        },

        companyConfirmBooking:           function (e) {
            this.step = 'company-confirm-booking';
            if (!this.shouldSubmit(e)) {
                return;
            }
            const form = document.querySelector('[data-booking-step=company-confirm-booking]');
            let data = new FormData(form)
            if (TABS.optima.hasResourcePool) {
                for (const studentId in TABS.optima.resourceClassIds) {
                    data.append('resource_class_ids[' + studentId + ']', TABS.optima.resourceClassIds[studentId])
                }
            }
            this.request('company-confirm-booking', form, this.companyConfirmBookingCallback, data);
        },
        companyConfirmBookingCallback:   function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');
            if (!res.success) {
                TABS.booking.showError(res.message);
                return;
            }

            if (typeof res.purchaseEvent !== 'undefined') {
                TABS.analytics.triggerPurchaseEvent(res.purchaseEvent);
            }

            TABS.booking.showSuccess(res.message);
            form.remove();
        },
        companyAddStudent:               function (e, action) {
            this.step = 'company-add-student';
            const form = document.querySelector('[data-booking-step=company-add-student]');
            const data = new FormData(form);
            const registered = document.querySelectorAll('#company-confirm-booking-form input[data-type=student_ids]');
            if (!data.get('mobile') && !data.get('first_name') && !data.get('last_name') && registered.length && action === 'confirm-booking') {
                // Input empty and user wants to confirm - go straight to confirm booking instead of trying to add new participant
                this.showStep('company-confirm-booking');
                this.showSuccess(TABS.$t('Deltagere registrert. Bekreft bestillingen for å fullføre.'));
                this.setLoading(false);
                return;
            }

            if (!this.shouldSubmit(e)) {
                return;
            }
            let callback = this.companyAddLastStudentCallback;
            if (action === 'next-student') {
                callback = this.companyAddMoreStudentsCallback;
            }

            this.clearCompanyAddStudentErrors(form);
            this.setFeedback('');
            this.request('company-add-student', form, callback);
        },
        companyRemoveStudent:            function (e, studentId) {
            document.querySelector('#company-confirm-booking-form .student-list [data-student-id=' + studentId + ']').remove();
            document.querySelector('#company-confirm-booking-form input[type=hidden][value=' + studentId + ']').remove();
            document.querySelector('#company-confirm-booking-form [data-student-id=' + studentId + '][type=hidden]').remove();
            document.querySelector('.company-user-list p[data-student-id=' + studentId + ']').remove();
        },
        companyAddMoreStudentsCallback:  function (res, form) {
            TABS.booking.resetButtons(form);
            form.querySelector('.student-intro-message').classList.add('hide');
            if (!res.success) {
                if (res.errors) {
                    return TABS.booking.showCompanyAddLastStudentErrors(form, res.errors);
                } else if (res.message) {
                    return TABS.booking.showError(res.message);
                }
            }

            if (TABS.optima.hasResourcePool) {
                TABS.optima.resourceClassIds[res.data.student_id] = form.querySelector('select[name=resource-class-id]').value
            }

            // Success, should add user to list on left
            const companyUserList = document.querySelector('.company-user-list');
            const fullname = form.querySelector('input[name=first_name]').value + ' ' + form.querySelector('input[name=last_name]').value;
            companyUserList.classList.remove('hide');
            companyUserList.insertAdjacentHTML('beforeend', '<p data-student-id="' + res.data.student_id + '"><strong><i class="tabs-fa tabs-fa-block tabs-fa-user"></i> ' + TABS.$t('Navn') + ': ' + fullname + '</strong></p>');
            document.querySelector('#company-confirm-booking-form').insertAdjacentHTML('beforeend', '<input type="hidden" data-type="student_ids" name="student_ids[]" value="' + res.data.student_id + '">');
            document.querySelector('#company-confirm-booking-form').insertAdjacentHTML('beforeend', '<input type="hidden" data-type="student_booking_comments" name="student_booking_comments[]" data-student-id="' + res.data.student_id + '" value="' + form.querySelector('textarea[name=company-comment]').value + '">');
            document.querySelector('#company-confirm-booking-form .student-list').insertAdjacentHTML('beforeend', '<p data-student-id="' + res.data.student_id + '"> <span class="btn btn-danger btn-sm rounded-0 cursor-pointer" style="margin-right: 5px;" title="' + TABS.$t('Fjern') + '" onclick="TABS.booking.companyRemoveStudent(event, ' + res.data.student_id + ')"><i class="fa fa-close"></i></span> ' + fullname + '</p>');
            // Clear form for next participant
            form.querySelectorAll('input[type=text],textarea, select').forEach(el => el.value = '');
            // Reset optima student details form
            form.querySelectorAll('.register-details').forEach(el => el.classList.add('hide'));
        },
        clearCompanyAddStudentErrors:    function (form) {
            form.querySelectorAll('p.text-danger').forEach(el => el.textContent = '');
        },
        showCompanyAddLastStudentErrors: function (form, errors) {
            TABS.booking.clearCompanyAddStudentErrors(form);
            Object.keys(errors).forEach(key => {
                form.querySelector('p.text-danger[data-error=' + key + ']').textContent = errors[key];
            });
        },
        companyAddLastStudentCallback:   function (res, form) {
            // Do the same as usual but we also wanna navigate to the confirm booking form here
            TABS.booking.companyAddMoreStudentsCallback(res, form);
            if (!res.success) {
                return; // Not successful - dont continue
            }

            TABS.booking.showStep('company-confirm-booking');
            TABS.booking.showSuccess(TABS.$t('Deltagere registrert. Godkjenn bookingdetaljene for å fullføre.'));
        },

        showError:   function (message) {
            TABS.booking.setFeedback('<p class="alert alert-danger">' + message + '</p>');
        },
        showSuccess: function (message) {
            TABS.booking.setFeedback('<p class="alert alert-success">' + message + '</p>');
        },

        ajaxError:             function (form, message) {
            TABS.booking.setLoading(false);
            if (!message) {
                message = TABS.$t('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.');
            }
            TABS.booking.showError(message);
            TABS.booking.resetButtons(form);
        },
        resetButtons:          function (form) {
            if (!form) {
                return;
            }
            form.querySelectorAll('.btn-primary').forEach(btn => {
                const originalText = btn.dataset.original ?? btn.dataset.originalText ?? TABS.$t('Fortsett');
                btn.removeAttribute('disabled');
                btn.textContent = originalText;
            });
        },
        setEndpoint:           function (endpoint) {
            TABS.booking.endpoint = endpoint;
        },
        triggerAnalyticsEvent: function (action, label, value) {
            TABS.analytics.triggerAnalyticsEvent(this.endpoint, action, label, value)
        },

        vippsLogin: function (btn, e) {
            e.preventDefault();

            const form = document.querySelector('[data-booking-step=bookingTypeSelect]');
            let currOfficeId = form.querySelector('[name=office_id]').value
            if (!currOfficeId) {
                currOfficeId = officeId
            }

            let url = TABS.api.getAuthHost() + '/vipps/login?';
            url += 'officeId=' + currOfficeId;
            url += '&classId=' + form.querySelector('[name=class_id]').value;
            if (form.querySelector('[name=course_id]')) {
                url += '&courseId=' + form.querySelector('[name=course_id]').value;
            } else if (form.querySelector('[name=package_id]')) {
                url += '&packageId=' + form.querySelector('[name=package_id]').value;
            } else if (form.querySelector('[name=follow_up_id]')) {
                url += '&followUpId=' + form.querySelector('[name=follow_up_id]').value;
            } else {
                url += '&teacherId=' + form.querySelector('[name=teacher]').value;
                url += '&productId=' + form.querySelector('[name=product_id]').value;
                url += '&start=' + form.querySelector('[name=start]').value;
                url += '&end=' + form.querySelector('[name=end]').value;
            }
            url += '&referer=' + TABS.api.getReferer();
            window.top.location.href = url;
        },

        logout: function (event) {
            if (event) {
                event.preventDefault();
            }
            TABS.booking.setLoading(true)
            this.request('logout', null, function (res) {
                TABS.booking.setLoading(false)
                const originalUrl = window.location.href;
                if (window.top.location !== window.location) {
                    window.top.location.href = TABS.api.getReferer();
                    return;
                }
                const token = TABS.util.getUrlParameter('tabs_jwt');
                if (token) {
                    window.history.pushState({}, '', originalUrl.replace('tabs_jwt=' + token, ''));
                    document.querySelector('input[name=student_vipps_user_id]').value = ''
                    document.querySelector('input[name=contact_vipps_user_id]').value = ''
                }
                document.getElementById('logged-in-state').classList.add('hide')
                document.getElementById('logged-out-state').classList.remove('hide')
                document.querySelector('input[name=login_hash]').value = ''
                document.querySelectorAll('#booking-accordions input[name=password], #booking-accordions input[name=username]').forEach(el => el.value = '')
                document.getElementById('identify-password-field').classList.add('hide')
                TABS.wizard.disableStep2()
            }, null);

        },

        triggerVipps: function () {
            if (TABS.booking.loading) {
                return;
            }
            TABS.booking.setLoading(true);

            const data = TABS.booking.getPaymentData()

            TABS.booking.request('trigger-vipps', null, function (res) {

                TABS.booking.setLoading(false);

                if (res.success) {
                    if (res.data.redirect) {
                        window.location = res.data.message
                        return
                    }
                    return TABS.booking.showError(TABS.$t('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.'));
                } else {
                    return TABS.booking.showError(res.error);
                }
            }, data);
        },

        getPaymentData: function () {
            const form = document.getElementById('booking-form-inputs')
            const terms = document.getElementById('confirm-and-complete-accordion-body')
            let productTerms = {};
            terms.querySelectorAll('input[name^=product_term_approved][type=hidden], input[name^=product_term_approved][type=checkbox]:checked').forEach(el => {
                productTerms[el.name] = el.value;
            });
            return {
                user_id:       form.querySelector('input[name=student_id]') ? form.querySelector('input[name=student_id]').value : null,
                class_id:      form.querySelector('input[name=class_id]') ? form.querySelector('input[name=class_id]').value : null,
                course_id:     form.querySelector('input[name=course_id]') ? form.querySelector('input[name=course_id]').value : null,
                teacher_id:    form.querySelector('input[name=teacher]') ? form.querySelector('input[name=teacher]').value : null,
                product_id:    form.querySelector('input[name=product_id]') ? form.querySelector('input[name=product_id]').value : null,
                package_id:    form.querySelector('input[name=package_id]') ? form.querySelector('input[name=package_id]').value : null,
                start:         form.querySelector('input[name=start]') ? form.querySelector('input[name=start]').value : null,
                end:           form.querySelector('input[name=end]') ? form.querySelector('input[name=end]').value : null,
                product_terms: productTerms,
            }
        },
    }
})();